import axios from 'axios';
import { DataService } from './DataService';

const MINTBOX_CLIENT_ID = 'Li2L9VO1eawEbsgLrHdpZjhmUdW6N8Cm';

const API_ENDPOINT = 'https://pyapi.mintbox.ai/api';

const client = axios.create({
	baseURL: API_ENDPOINT,
	withCredentials: false
});

class DataServicePY {
	static get(path = '', data = {}) {
		const optional = { 'Content-Type': 'application/json' };

		return client({
			method: 'GET',
			url: path,
			headers: { ...axios.defaults.headers, ...optional }
		});
	}

	static post(path = '', data = {}) {
		const optional = { 'Content-Type': 'application/json' };

		return client({
			method: 'POST',
			url: path,
			data: JSON.stringify(data),
			headers: { ...axios.defaults.headers, ...optional }
		});
	}

	static postFile(path = '', data = {}) {
		const optional = { 'Content-Type': 'multipart/form-data' };

		return axios.post(API_ENDPOINT + path, data, {
			headers: { ...axios.defaults.headers, ...optional }
		})
		// return client({
		// 	method: 'POST',
		// 	url: path,
		// 	file: data,
		// 	headers: { ...axios.defaults.headers, ...optional }
		// });
	}

	static postImg(path = '', data = {}) {

		return fetch(API_ENDPOINT + path, {
			method: 'POST',
			body: data
		}).then(r => r.json())
			.then(data => {
				if (data.statusCode === 200) {
					return {
						msg: 'Success',
						data: data.response,
						type: true
					};
				} else {
					return data;
				}

			})
	}

	static patch(path = '', data = {}) {
		const optional = { 'Content-Type': 'application/json' };

		return client({
			method: 'PATCH',
			url: path,
			data: JSON.stringify(data),
			headers: { ...axios.defaults.headers, ...optional }
		});
	}

	static put(path = '', data = {}) {
		const optional = { 'Content-Type': 'application/json' };

		return client({
			method: 'PUT',
			url: path,
			data: JSON.stringify(data),
			headers: { ...axios.defaults.headers, ...optional }
		});
	}

	static delete(path = '', data = {}) {
		const optional = { 'Content-Type': 'application/json' };

		return client({
			method: 'DELETE',
			url: path,
			headers: { ...axios.defaults.headers, ...optional }
		});
	}
}

const getAccessToken = async () => {
	const token = await localStorage.getItem('access_token');
	return JSON.stringify({ access_token: token || '' });
};

const refreshAccessToken = async () => {
	const res = await DataService.get(`/Auth/getToken?clientId=${MINTBOX_CLIENT_ID}`).then((d) => d);
	if (res.type) {
		await localStorage.setItem('access_token', res.data.accessToken);
		return res.data.accessToken;
	}
	return '';
};

client.interceptors.request.use(
	async (config) => {
		const value = await getAccessToken();
		const keys = JSON.parse(value);

		config.headers.Authorization = `Bearer ${keys.access_token}`

		return config;
	},
	(error) => {
		Promise.reject(error);
	}
);

client.interceptors.response.use(
	(response) => {
		if (response.status === 200) {
			return {
				msg: 'Success',
				data: response.data,
				type: true
			};
		}
		// Toast.show({
		//   text1: 'Error Occured!!',
		//   text2: 'Try again ...',
		//   type: 'error'
		// });
		return {
			msg: response.statusText,
			data: response.data,
			type: false
		};
	},

	async (error) => {
		const { response } = error;
		const originalRequest = error.config;

		console.log(response)

		if (response) {
			// if (response.status === 401) {
			// 	originalRequest._retry = true;
			// 	const access_token = await refreshAccessToken();
			// 	console.log('aaac = ', access_token);
			// 	axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
			// 	return client(originalRequest);
			// } if (response.status === 500) {
			// 	originalRequest._retry = true;
			// 	const access_token = await refreshAccessToken();
			// 	console.log('aaac = ', access_token);
			// 	axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
			// 	return client(originalRequest);
			// }
			// Toast.show({
			//   text1: 'Error Occured!!',
			//   text2: 'Try again ...',
			//   type: 'error'
			// });
			return response;
		}

		return Promise.reject(error);
	}
);

export { DataServicePY, API_ENDPOINT };
